import React from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'
import {
	/* MoreVert, */ DragIndicator,
	Person,
	Close,
} from '@material-ui/icons'

const styles = (theme) => ({
	label: {
		position: 'absolute',
		left: 81,
		top: 36,
		color: '#000',
		[theme.breakpoints.down('sm')]: {
			fontSize: 12,
		},
	},
	// icon: {

	// },
})

const ItemUI = ({
	id,
	isDragging,
	item,
	index,
	user,
	onDelete,
	lastAssignedUserID,
	classes,
}) => {
	return (
    <div
      style={{
        height: 60,
        margin: 10,
        paddingLeft: 40,
      }}
    >
      <div
        style={{
          border: isDragging ? 'none' : '1px solid #000',
          position: 'relative',
          height: 60,
          borderRadius: 21,
          backgroundColor: '#d5e6f8',
          paddingLeft: 80,
        }}
      >
        <div
          style={{
            height: 30,
            width: 30,
            borderRadius: '50%',
            backgroundColor: '#014c94',
            color: '#fff',
            position: 'absolute',
            left: -48,
            textAlign: 'center',
            top: '50%',
            transform: 'translate(0, -50%)',
          }}
        >
          <div style={{ height: 30, width: 30, position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
            >
              {index + 1}
            </div>
          </div>
        </div>
        <div
          style={{
            position: 'absolute',
            left: 7,
            top: '50%',
            transform: 'translate(0, -50%)',
            color: '#8a92ac',
            cursor: 'pointer',
          }}
        >
          <DragIndicator />
        </div>
        <div
          style={{
            position: 'absolute',
            left: 27,
            top: /* lastAssignedUserID === item?.id ? -5 : */ '50%',
            transform:
              /* lastAssignedUserID === item?.id
								? undefined
								: */ 'translate(0, -50%)',
            color: '#49476a',
          }}
        >
          <Person style={{ fontSize: 50 }} />
        </div>
        <div style={{ position: 'relative', height: 60 }}>
          <div
            style={{
              position: 'absolute',
              top: lastAssignedUserID === item?.id ? 10 : '50%',
              left: 0,
              transform:
                lastAssignedUserID === item?.id
                  ? undefined
                  : 'translate(0, -50%)',
            }}
          >
            <div style={{ fontSize: 19, color: '#3e3b5f', fontWeight: 'bold' }}>
              {user?.first_name || ''} {user?.last_name || ''}
            </div>
          </div>
        </div>
        {(lastAssignedUserID || typeof lastAssignedUserID === 'number') &&
        lastAssignedUserID === item?.id ? (
          <div className={classes.label} onClick={() => onDelete(index)}>
            last assigned a contact
          </div>
        ) : null}
        <div
          style={{
            position: 'absolute',
            right: 15,
            top: '50%',
            transform: 'translate(0, -50%)',
            color: '#d5e6f8',
            backgroundColor: '#014c94',
            cursor: 'pointer',
            height: 25,
            width: 25,
            borderRadius: '50%',
            textAlign: 'center',
          }}
          onClick={() => onDelete(index)}
        >
          <Close />
        </div>
      </div>
    </div>
  )
}

export default connect(
	(state, { item, assignmentPoolSelected }) => ({
		user: state.data?.['account/user']?.[item?.username],
		lastAssignedUserID:
			state.data?.['account/ap']?.[assignmentPoolSelected]?.pool
				?.lastassigneduser?.id,
	}),
	null,
)(withStyles(styles)(ItemUI))
